import { getLocalTimezone } from 'lib/time'
import { FillStatusText } from 'pages/HomePage/ShiftCard/FillStatusText'
import { useWorkerStats } from 'pages/HomePage/ShiftCard/useWorkerStats'
import { useLedShifts } from 'queries/shift'
import { QueryData } from 'queries/types'
import { Box, Card, Flex, Link, ProgressBar } from '@workwhile/ui'
import { ShiftSummary } from './ShiftSummary'
import { ShiftWorkerAvatars } from './ShiftWorkerAvatars'

interface Props {
  shift: QueryData<typeof useLedShifts>[number]
}

export const LinkedShiftCard = ({ shift }: Props) => {
  const timezone = shift.location?.timezone || getLocalTimezone()
  const { workers, totalWorkers } = useWorkerStats(shift)

  return (
    <Card borderWidth={0} height="100%">
      <ShiftSummary
        positionName={shift.position.name}
        startsAt={shift.startsAt}
        endsAt={shift.endsAt}
        timezone={timezone}
        locationName={shift.location?.name}
      />
      <Flex alignItems="center" mt={3}>
        <Box flex={1} mr={3}>
          <ShiftWorkerAvatars shift={shift} />
        </Box>
        <Box flex={1}>
          <FillStatusText shift={shift} />
          <ProgressBar
            mt={2}
            width={1}
            max={totalWorkers.length}
            value={workers.length}
            aria-label="Shift Filled Progress"
          />
        </Box>
      </Flex>
      <Box mt="auto" pt={3}>
        <Link to={`/shift/${shift.id}`}>View shift details</Link>
      </Box>
    </Card>
  )
}
